import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { saveAs } from 'file-saver';
import * as d3 from 'd3';
import { ScatterComponent } from 'src/app/shared/graphs/scatter/scatter.component';
import { Google_map } from 'src/app/shared/google_map';

@Component({
  selector: 'app-logscengps',
  templateUrl: './logscengps.component.html',
  styleUrls: ['./logscengps.component.css']
})
export class LogscengpsComponent extends BaseComponent implements OnChanges{
  @ViewChild('pagemap2', { static: true }) mapElement: any = {}
  @Input() scenarioId = 0
  @ViewChild('scatter1') scatter1: ScatterComponent;
  @ViewChild('scatter2') scatter2: ScatterComponent;
  overview: any = []
  records: any = []
  gpslogs: any = []
  scenario: any = {}
  scenariolayout: any = {}
  google_map: Google_map
  heightmin = 100
  heightmax = 0
  selectedScenario: any = {}
  counter = 0
  walkInterval = "200"
  googlemapcircles: any = [];
  showAccuracy :any;
  showRecords = false
  showmapheader = false;
  phoneinfo = ""
  sortDir: any = []

  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show();

    this.overview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: this.scenarioId });
    this.overview.forEach((s: any) => {
      s.date = new Date(s.firstRecord.dateCreated);        
    })
    this.loader.hide();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.scenarioId > 0){
      this.overview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: this.scenarioId })
      this.overview.forEach((s: any) => {
        s.date = new Date(s.firstRecord.dateCreated);        
      })
    }
  }
  async selectByPhoneInfo(p:any){
    this.phoneinfo = p.name
    this.gpslogs = await this.db.get("gpslog", "getgpslogsbyphoneinfo", { phoneinfo: this.phoneinfo });
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioId })

    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = JSON.parse(this.scenario.geometryJson)
      this.showMap()
    }
  }
  deleteAllPhoneInfo(p:any){

  }
  showMap() {
    this.google_map = new Google_map()
    let latlng = this.scenariolayout.center
    let zoom = this.getZoom()
    this.google_map.init(this.mapElement.nativeElement, latlng, zoom)
    this.google_map.setMarker(latlng, "Center");

    this.scenariolayout.contours.forEach((p: any, i: number) => {
      let color = this.scenariolayout.contourdefinitions[i].color;
      this.google_map.addPolygon(p, color)
    })
    this.heightmin = 100
    this.heightmax = 0
    this.gpslogs.forEach((l: any) => {
      let latlng = { lat: l.latitude, lng: l.longitude }
      if (l.height > this.heightmax) { this.heightmax = l.height}
      if (l.height < this.heightmin) this.heightmin = l.height
    })

    this.googlemapcircles = []
    this.gpslogs.forEach((l: any,index: number) => {
      
      this.drawLog(index)
    })

  }

  componentToHex(c:number) {
    let i = Math.floor(c)
    let hex = i.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  
  rgbToHex(r:number, g:number, b:number) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }
  

  getZoom() {
    let result = 14
    let min = 0
    let max = 0
    if (this.scenariolayout.contours.length > 0) {
      min = this.scenariolayout.contours[0][0].lat
      max = this.scenariolayout.contours[0][0].lat
      this.scenariolayout.contours.forEach((c: any) => {
        c.forEach((ll: any) => {
          if (ll.lat < min) min = ll.lat
          if (ll.lat > max) max = ll.lat
        })
      })
      let diff = max - min
      if (diff < 0.010) result = 15
      if (diff < 0.002) result = 17
    }
    return result
  }
  showWalk(){
    this.clearCircles()
    this.counter = 0
    this.repeatLoop()
  }

  repeatLoop() {
    console.log(this.counter);
    this.drawLog(this.counter)
    this.counter++;
    if (this.counter < this.gpslogs.length) {
      let interval = parseInt(this.walkInterval) * 1
      setTimeout(this.repeatLoop.bind(this), interval); // 1000 milliseconds = 1 second
    }
  }

  clearCircles(){
    this.googlemapcircles.forEach((c:any) =>{
      c.setMap(null);
    })
    this.googlemapcircles = []
  }

  drawLog(index: number){
    let l = this.gpslogs[index]
    let r = 255 * (l.height / this.heightmax)
    let b = 255 - 255 * (l.height / this.heightmax)
    let sColor = this.rgbToHex(r,0,b)
    if (this.showAccuracy) sColor = this.rgbToHex(0,255,0)
    let latlng = { lat: l.latitude, lng: l.longitude }
    let radius = this.showAccuracy  ? l.accuracy : 2
    let transparency =  this.showAccuracy  ? 0.1 : 1.0
    let circle = this.google_map.addCircleNoTrans(latlng, radius, sColor,transparency);
    this.googlemapcircles.push(circle)
  }
  async deleteSelected(b:any){
    this.confirm.show("Do you really want to delete tall records for phone info " + b.name + "?",
    () => {
      this.deleteRecords(b.name)
    }, () => {
      this.toast.info("Nothing to do")
    })

  }
  async deleteRecords(phoneinfo: string){
    await this.db.delete("gpslog", "deleteGPSLogByScenAndPhoneInfo", { scenarioid: this.scenarioId, phoneinfo: phoneinfo  });
    this.overview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: this.scenarioId });
  }
  sortCol(fieldname:string){
    this.sortGeneric(this.overview,fieldname,this.sortDir)
  }
  deleteAllRecords(){
    this.confirm.show("Do you really want to delete all records for this scenario?",
    async () => {
      await this.db.delete("gpslog", "deleteGPSLogByScen", { scenarioid: this.scenarioId });
      this.overview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: this.scenarioId });
    }, () => {
      this.toast.info("Nothing to do")
    })
  }
}
